<template>
  <div class="s-professionalInfos-onsultation-container">
    <topNav></topNav>
    <div class="s-professionalInfos-onsultation-top">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <div class="s-expert-advice-list-container w1300 marginAuto">
      <div class="s-expert-advice-list-left-nav">
        <div
          v-for="(item,index) in expertNav"
          :key="index"
          :class="[currentExpertNav == item?'s-left-nav-active':'']"
          @click="handleExpertNav(item)"
        >{{item}}</div>
      </div>

      <product-analysis v-if="currentExpertNav == '生产分析'"></product-analysis>
      <alarm-info v-if="currentExpertNav == '预警推送'"></alarm-info>
      <production-model v-if="currentExpertNav == '生产模型预测'"></production-model>
      <price-model v-if="currentExpertNav == '价格模型预测'"></price-model>
      <consume-model v-if="currentExpertNav == '消费模型预测'"></consume-model>
    </div>

    <footer-nav></footer-nav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";

import ProductionModel from "../components/model/ProductionModel.vue";
import PriceModel from "../components/model/PriceModel.vue";
import ConsumeModel from "../components/model/ConsumeModel.vue";
import ProductAnalysis from "../components/model/ProductAnalysis.vue";
import AlarmInfo from "../components/model/AlarmInfo.vue";
export default {
  name: "professionalInfoConsultation",
  data() {
    return {
      expertNav: [
        "生产分析",
        "预警推送",
        "生产模型预测",
        "价格模型预测",
        "消费模型预测",
      ],
      currentExpertNav: "生产分析"
    };
  },
  components: {
    topNav,
    footerNav,
    ProductionModel,
    PriceModel,
    ConsumeModel,
    ProductAnalysis,
    AlarmInfo
  },
  mounted() {},
  methods: {
    handleExpertNav(value) {
      this.currentExpertNav = value;
    }
  }
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/professionalInfoConsultation.scss";
.modelApplyScreen .el-input {
  width: 170px;
}
.el-button:focus,
.el-button:hover {
  color: #3ba756 !important;
  border-color: #c6e2ff;
  background-color: #fff !important;
}

.el-button--success,
.el-button--success:focus,
.el-button--success:hover {
  background: #3ba756 !important;
  border-color: #3ba756 !important;
  color: #fff !important;
}

.el-button--primary {
  background-color: #3ba756 !important;
  border-color: #3ba756 !important;
  color: #fff !important;
}

.el-button--primary:focus,
.el-button--primary:hover {
  background: #3ba756 !important;
  border-color: #3ba756 !important;
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
.s-expert-advice-list-container {
  margin: 30px auto;
  .s-expert-advice-list-left-nav {
    height: 280px;
  }
}
</style>
